module.exports = __webpack_public_path__ + "static/media/YF87_6.67b5d905.jpg";